import {
  dailyRoutineLevels,
  packSchoolbagLevels,
  schoolScenarioLevels
} from "@/content/habits";
import { DIFFICULTIES } from "@/domain/schemas";

import { createDailyRoutineBinding } from "./daily-routine-binding";
import { createSchoolScenarioBinding } from "./school-scenario-binding";
import { createSchoolbagBinding } from "./schoolbag-binding";
import type {
  DailyRoutineBinding,
  HabitsLevelBinding,
  HabitsPlayerActivityType,
  SchoolbagBinding,
  SchoolScenarioBinding
} from "./types";

export const HABITS_DAILY_ROUTINE_BINDINGS: readonly DailyRoutineBinding[] =
  dailyRoutineLevels.map(createDailyRoutineBinding);

export const HABITS_SCHOOLBAG_BINDINGS: readonly SchoolbagBinding[] =
  packSchoolbagLevels.map(createSchoolbagBinding);

export const HABITS_SCHOOL_SCENARIO_BINDINGS: readonly SchoolScenarioBinding[] =
  schoolScenarioLevels.map(createSchoolScenarioBinding);

export const HABITS_LEVEL_BINDINGS: readonly HabitsLevelBinding[] = [
  ...HABITS_DAILY_ROUTINE_BINDINGS,
  ...HABITS_SCHOOLBAG_BINDINGS,
  ...HABITS_SCHOOL_SCENARIO_BINDINGS
];

function assertCompleteActivityTiers(
  activityType: HabitsPlayerActivityType,
  bindings: readonly HabitsLevelBinding[]
): void {
  const activityBindings = bindings.filter(
    (binding) => binding.activityType === activityType
  );
  const difficulties = activityBindings.map(
    ({ level }) => level.difficulty
  );

  if (
    activityBindings.length !== DIFFICULTIES.length ||
    DIFFICULTIES.some((difficulty) => !difficulties.includes(difficulty))
  ) {
    throw new Error(
      "Habits player must bind difficulties 1 through 6 for " + activityType
    );
  }
}

const bindingByLevelId = new Map<string, HabitsLevelBinding>();

for (const binding of HABITS_LEVEL_BINDINGS) {
  if (bindingByLevelId.has(binding.level.id)) {
    throw new Error("Duplicate Habits player binding " + binding.level.id);
  }

  bindingByLevelId.set(binding.level.id, binding);
}

assertCompleteActivityTiers("daily-routine", HABITS_LEVEL_BINDINGS);
assertCompleteActivityTiers("pack-schoolbag", HABITS_LEVEL_BINDINGS);
assertCompleteActivityTiers("school-scenarios", HABITS_LEVEL_BINDINGS);

export function getHabitsLevelBinding(
  levelId: string
): HabitsLevelBinding | undefined {
  return bindingByLevelId.get(levelId);
}
